var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loadingComponent"},[_c('div',{staticClass:"loading"},[_c('img',{staticClass:"loadingImage",attrs:{"alt":"Loading","src":require("@/assets/logo-orange-side.png")}})])])
}]

export { render, staticRenderFns }